/**
 * The role(s) a user holds, as badges.
 *
 * One badge for a single-sided company — exactly what User Management has
 * always shown. For a company that trades on both portal sides (CR-7255) one
 * badge per side, so the table and the details modal say the same thing the
 * Change Roles dialog edits.
 */
import { Badge } from '../../components/ui/badge';
import type { UserProfile } from '../../lib/api';

interface RoleBadgesProps {
  userProfile: UserProfile;
  className?: string;
}

export function RoleBadges({ userProfile, className = 'text-xs' }: RoleBadgesProps) {
  if (!userProfile.is_dual_company) {
    return <Badge variant="outline" className={className}>{userProfile.role_name}</Badge>;
  }
  const customer = userProfile.side_roles?.find((r) => r.side === 'customer');
  const supplier = userProfile.side_roles?.find((r) => r.side === 'supplier');
  return (
    <div className="flex flex-wrap gap-1" data-testid="side-role-badges">
      <Badge variant="outline" className={className}>
        Customer: {customer?.role_name || userProfile.role_name || 'none'}
      </Badge>
      <Badge variant="outline" className={className}>
        Supplier: {supplier?.role_name || 'none'}
      </Badge>
    </div>
  );
}
